module.exports = __webpack_public_path__ + "img/congratulations.a02a5325.svg";